import React from 'react';
import { Container, Icon } from './styled';
import { ReactComponent as Twitter } from 'assets/social/twitter.svg';
import { ReactComponent as TikTok } from 'assets/social/tiktok.svg';
import { ReactComponent as Facebook } from 'assets/social/facebook.svg';
import { ReactComponent as Instagram } from 'assets/social/instagram.svg';
import { ReactComponent as Medium } from 'assets/social/medium.svg';
import { ReactComponent as Telegram } from 'assets/social/telegram.svg';
import { GAHandler } from 'utils/GA';

const index = () => {
  const rrss = [
    {
      href: 'https://www.instagram.com/somos.flixxo/',
      icon: Instagram,
      label: 'Instagram'
    }, {
      href: 'https://www.tiktok.com/@somosflixxo',
      icon: TikTok,
      label: 'TikTok'
    }, {
      href: 'https://www.facebook.com/somos.flixxo/',
      icon: Facebook,
      label: 'Facebook'
    }, {
      href: 'https://twitter.com/flixxo',
      icon: Twitter,
      label: 'Twitter'
    }, {
      href: 'https://t.me/flixxo',
      icon: Telegram,
      label: 'Telegram'
    }, {
      href: 'https://flixxo.medium.com/',
      icon: Medium,
      label: 'Medium'
    },
  ];

  const handleClick = (label) => {
    const newLabel = label.toLowerCase()
    GAHandler(`ui_social_${newLabel}`);
    
  }

  return (
    <Container>
      {rrss.map(({icon, href, label}) => (
        <a
          href={href}
          onClick={() => handleClick(label)}
          onAuxClick={() => handleClick(label)}
          key={href}
          target='_blank'
          rel="noreferrer noopener"
        >
          <Icon as={icon}/>
        </a>
      ))}
    </Container>
  )
}

export default index
